"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Validates if input is a real Date.
 *
 * @export
 * @class IsDateValidator
 * @implements {PropertyValidator<any>}
 */
class IsDateValidator {
    isValid(input) {
        return input instanceof Date;
    }
}
exports.IsDateValidator = IsDateValidator;
//# sourceMappingURL=IsDateValidator.js.map